var map = {
	"./b_b.svg": 337,
	"./b_w.svg": 772,
	"./k_b.svg": 16,
	"./k_w.svg": 917,
	"./n_b.svg": 645,
	"./n_w.svg": 384,
	"./p_b.svg": 727,
	"./p_w.svg": 906,
	"./q_b.svg": 678,
	"./q_w.svg": 891,
	"./r_b.svg": 993,
	"./r_w.svg": 724
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 752;